import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { deepExtend } from "../../../../Utils/Utils";
import { setRangeValue } from "../../../../Utils/NumberUtils";
export var Spin = /*#__PURE__*/function () {
  function Spin() {
    _classCallCheck(this, Spin);

    this.acceleration = 0;
    this.enable = false;
  }

  _createClass(Spin, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }

      if (data.acceleration !== undefined) {
        this.acceleration = setRangeValue(data.acceleration);
      }

      if (data.enable !== undefined) {
        this.enable = data.enable;
      }

      if (data.position) {
        this.position = deepExtend({}, data.position);
      }
    }
  }]);

  return Spin;
}();